export enum ActivityActionType {
  NEW_UPDATE = 'NEW_UPDATE',
  NEW_ORGANISATION = 'NEW_ORGANISATION',
  NEW_PROJECT = 'NEW_PROJECT',
  NEW_PROJECT_UPDATE = 'NEW_PROJECT_UPDATE',
  ALL = 'ALL',
}
